export default "__VITE_ASSET__CdK2QQho__"